import { loginEmailSchema } from '../_schemas/loginFormSchemas';

import type { DeclarativeFormConfig } from '@bridge/ui';
import type { LoginEmailFormValues } from '../_schemas/loginFormSchemas';

export const getMagicLinkFormConfig = (): DeclarativeFormConfig<LoginEmailFormValues> => ({
  schema: loginEmailSchema,
  rows: [
    [
      {
        name: 'email',
        label: 'Email address',
        labelHidden: true,
        component: 'input',
        componentProps: {
          placeholder: 'Email address',
          type: 'email',
          autoComplete: 'email',
          className: 'h-12',
        },
      },
    ],
  ],
});

export const getSSOFormConfig = (): DeclarativeFormConfig<LoginEmailFormValues> => ({
  schema: loginEmailSchema,
  rows: [
    [
      {
        name: 'email',
        label: 'Email address',
        labelHidden: true,
        component: 'input',
        componentProps: {
          placeholder: 'Email address',
          type: 'email',
          autoComplete: 'email',
          autoFocus: true,
          className: 'h-12',
        },
      },
    ],
  ],
});
